module.exports = __webpack_public_path__ + "img/icon_microphone.114f9362.svg";